import { styled } from '@mui/system';
import colors from '../../../../theme/emotion/colors';

export const OnboardingTitle = styled('h1')({
  fontSize: '1.375rem',
  fontWeight: 600,
  fontFamily: 'Poppins, sans-serif',
  lineHeight: 1.2,
  margin: 0,
  color: colors.primary.dark,
  '@media (max-height: 700px)': {
    fontSize: '1.25rem',
  },
});

export const OnboardingDescription = styled('p')({
  fontSize: '0.875rem',
  fontWeight: 400,
  fontFamily: 'Poppins, sans-serif',
  lineHeight: 1.4,
  margin: 0,
  color: 'rgba(0, 0, 0, 0.6)',
}); 